export const WorkspaceSettingsSidebarTestIdFactory = {
    getDevelopersGroupTestId: () => 'developers',
    getDeveloperToolsItemTestId: () => 'sidebar-item-to-developer-tools',
};
